module.exports = __webpack_public_path__ + "img/Icon_PowerPoint.fe8fcbb5.svg";